import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Toolbar,
  Typography,
  Box,
  Avatar,
  Menu,
  MenuItem,
  FormControl,
  Select,
  Divider,
  Grid,
  Button,
  TextField,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import MuiAppBar from "@mui/material/AppBar";
import { connect } from "react-redux";
import { LOGOUT_START } from "Actions/AuthAction";
import { helpMenuList, profileMenuItem, sidebarMenuItems } from "utils/data";
import {
  getLocalStorage,
  capitalizeFirstLetter,
  setLocalStorage,
} from "utils/generalUtils";
import { START_GET_PHARMACY_CONFIG } from "Actions/UserAction";
import { SET_HEADER_FILTER_PHARMACIES } from "Actions/PharmacyAction";
import { useLocation, useNavigate } from "react-router-dom";
import {
  START_CHASEUP_CHART,
  START_GET_NO_OF_ALERT,
  START_ORDER_CHART,
} from "Actions/HomeAction";
import { getRemovedUrlParam } from "utils/generalUtils";
import { createSearchParams } from "react-router-dom";
import { ReactComponent as AlertIcon } from "Assets/Icons/Alert.svg";
import { ReactComponent as Logout } from "Assets/Icons/Logout.svg";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import { START_GLOBAL_SETTING } from "Actions/RepeatOrderAction";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { START_PHARMACY_LIST } from "Actions/PatientAction";
import { useIntersection } from "Hooks/customHooks";
import PharmacyAutoComplete from "Components/Patients/PharmacyAutoComplete";
import HtmlTooltip from "./HtmlTooltipMain";
import { START_GET_HOME_LIST } from "Actions/HomeAction";
import { START_GET_COLLECTION_COUNT } from "Actions/CollectionAction";
import { START_ORDER_SPEED } from "Actions/OrderPadAction";
import EditProfileDialog from "./EditProfileDialog";
import BillingDialog from "./BillingDialog";
import HelpIcon from "@mui/icons-material/Help";
import clsx from "clsx";
import { ReactComponent as RepeatSmart } from "../../Assets/Logo/RepeatSmart.svg";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/CloseIcon.svg";
import { ReactComponent as Refresh } from "../../Assets/Icons/refresh.svg";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import zIndex from "@mui/material/styles/zIndex";
import ContactUsDialog from "../Common/ContactUsDialog";
import VideoDialogMain from "Components/HowTo/VideoDialogMain";
import Pagination from "./Pagination";
// html-react-parser import removed: all parse() call sites in this file are commented out
import { ReactComponent as RepeatSmartApp } from "Assets/Logo/RepeatSmartWhite.svg";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIconMain from "@mui/icons-material/Close";
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: "100%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const useStyle = makeStyles((theme) => ({
  rsToolBarRoot: {
    background: "unset !important ",
    boxShadow: "none !important",
    marginBottom: "0px",
    backgroundColor: "#7bbd4b !important",
    zIndex: "1300",
    boxShadow:
      "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px !important",
    "&>div": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
  rsHeaderRightSide: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "15px",
    },
    "& .MuiAvatar-root": {
      border: `2px solid ${theme.palette.white.main}`,
    },
    "&>button": {
      border: `1px solid${theme.palette.background.red} !important`,
      color: "#E6676B !important",
      background: theme.palette.white.main,
      "&:hover": {
        border: `none`,
        background: theme.palette.white.main,
      },
    },
  },
  rsFormControlRoot: {
    background: theme.palette.white.main,
    boxShadow: "0px 3px 4px rgba(26, 102, 122, 0.1)",
    borderRadius: "5px",
    marginRight: "20px !important",
    minWidth: "200px !important",
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  rsDivider: {
    background: `${theme.palette.background.grey} !important`,
    [theme.breakpoints.down("sm")]: {
      width: "358px",
    },
  },
  rsMainTitle: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px !important",
    },
  },
  rsProfileRole: {
    marginTop: "1px !important",
  },
  rsUserName: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "113px",
  },
  rsProfileIcon: {
    width: "45px !important",
    height: "46px !important",
    marginLeft: "0px !important",
  },
  rsFormControlRootPharmacyStaff: {
    background: theme.palette.white.main,
    boxShadow: "0px 3px 4px rgba(26, 102, 122, 0.1)",
    borderRadius: "5px",
    marginRight: "20px !important",
    minWidth: "172px !important",
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  select: {
    textAlign: "center",
    marginLeft: "10px",
  },
  rsBilling: {
    marginRight: "5px",
    whiteSpace: "nowrap",
    "&>button": {
      background: "white",
      color: "black",
      "&:hover": {
        background: "white",
        color: "black",
        opacity: "0.8",
      },
    },
  },
  rsBillingdaysleft: {
    marginRight: "20px",
    color: "red",
  },
  rshelpIconMain: {
    marginRight: "12px",
    marginLeft: "4px",
    "&>button": {
      // background: "black",
    },
  },
  rshelpButton: {
    // background: "black",
    color: "rgb(255, 255, 255) !important",
  },
  rsBoxColor: {
    position: "absolute",
    right: "10px",
    height: "fit-content",
    width: "450px",
    top: "80px",
    borderRadius: "10px",
    background: "white",
    boxShadow:
      "0px 8px 15px rgba(110, 117, 130, 0.15), 0px 1px 2px rgba(110, 117, 130, 0.3)",
    paddingBottom: "20px",
    zIndex: "15",
  },
  rsCloseIcon: {
    position: "absolute !important",
    right: "15px !important",
    top: "15px !important",
  },
  rsIconMain: {
    paddingTop: "25px",
    marginBottom: "10px",
    display: "flex",
    justifyContent: "center",
  },
  rsRowMain: {
    background: "#fff",
    border: "solid 1px #dddddd",
    borderRadius: "4px",
    marginTop: "10px",
    padding: "12px 14px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "10px",
    marginRight: "10px",
    "&>h5": {
      fontWeight: "500 !important",
      fontSize: "18px !important",
      color: "black",
    },
  },
  rsrighttitlecolor: {
    background: "rgba(234, 251, 227, 1)",
    borderRadius: "10px 10px 0px 0px",
    "&>h4": {
      color: "black",
      fontWeight: "600 !important",
      fontSize: "20px !important",
      paddingLeft: "20px",
      paddingBottom: "20px",
    },
  },
  main: {
    width: "70%",
    minWidth: "700px",
    background: "white",
    margin: "8px",
    padding: " 8px",
    display: "flex",
    borderRadius: "5px",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 1px #e9514e",
    position: "relative",
    "&>button": {
      position: "absolute",
      right: "10px",
      margin: "5px",
      height: "30px !important",
    },
    "&>nav": {
      position: "absolute",
      left: "10px",
    },
    "&>div": {
      "&>span": {
        "&>svg": {
          marginRight: "5px",
          "&>g": {
            "&>path": {
              fill: "#e9514e !important",
            },
          },
        },
      },
    },
  },
  textIocn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&>span": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&>svg": {
        width: "25px",
        height: "25px",
      },
    },
  },
  rspinBtn: {
    marginRight: "10px !important",
    transition: "0.25s ease-in-out",
    "&>svg": {
      width: "30px",
      height: "30px",
      "&>path": {
        fill: "white",
      },
      "&>g": {
        "&>path": {
          fill: "white",
        },
      },
    },
    background: "none !important",
    "&:hover": {
      background: "none !important",
    },
    "&:active": {
      background: "none !important",
    },
  },
  btnWhite: {
    background: "white !important",
    color: "#7BC044 !important",
    marginRight: "6px !important",
    width: "140px",
    fontSize: "1rem !important",
    fontWeight: "600 !important",
    border: "2px solid #7BC044",
    transition: "transform 1s ease",
    cursor: "pointer",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  howToBtn: {
    background: "white !important",
    color: "#7BC044 !important",
    marginRight: "10px !important",
    fontSize: "1rem !important",
    fontWeight: "600 !important",
    border: "2px solid #7BC044",
    transition: "transform 1s ease",
    cursor: "pointer",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
}));

function Header(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyle();
  const {
    logout,
    loginUserDetail,
    getPharmacyConfigAction,
    pharmacyConfigData,
    setHeaderFileterPharmaciesAction,
    getNoOfAlertAction,
    noOfAlertData,
    repeatOrderList,
    homeList,
    getGlobalSettingAction,
    getPharmacyListAction,
    pharmacyList,
    getHomeListAction,
    getOrderSpeedAction,
    getChaseupChartAction,
    getCollectionCountAction,
    getOrderChartAction,
    pin,
    setPin,
    setOpen,
    open,
    titleApp,
    setTitleApp,
    subTitleApp,
    setSubTitleApp,
  } = props;
  const query = new URLSearchParams(window.location.search);
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [changeDropDownValue, setChangeDropDownValue] = useState(
    selectedHeaderPharmacyId,
  );

  const [profileEditOpen, setProfileEditOpen] = useState(false);
  const [rightBarsetting, setRightBarsetting] = useState(false);
  const [unitPart, setUnitPart] = useState("days");
  const [isOrderDateMismtachSelected, setIsOrderDateMismtachSelected] =
    useState(query.has("orderDateMissmatch"));
  const [setTargetPharmacy, entryPharmacy] = useIntersection({
    threshold: 0.1,
  });
  const [paymentDialog, setPaymentDialog] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [openContactDialog, setOpenContactDialog] = useState(false);
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const [linkvideo, setLinkvideo] = useState("");
  const [title, setTitle] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [numberPart, setNumberPart] = useState(0);

  const itemsPerPage = 1;
  let tempDays = 10;
  let expireLimit = 31;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = noOfAlertData?.data?.data;
  let newObject = {};
  if (loginUserDetail?.data?.data?.is_applied_payment) {
    if (
      loginUserDetail?.data?.data?.is_trial &&
      loginUserDetail?.data?.data?.role != "super_admin" &&
      loginUserDetail?.data?.data?.is_new_user &&
      unitPart === "days"
    ) {
      if (!loginUserDetail?.data?.data?.is_expired) {
        newObject = {
          count: 0,
          key: "payment",
          label: `Trial:  ${loginUserDetail?.data?.data?.day_diff} left `,
        };
      } else {
        newObject = {
          count: 0,
          key: "payment",
          label: `Trial: expired`,
        };
      }
    }
    if (
      !loginUserDetail?.data?.data?.is_trial &&
      loginUserDetail?.data?.data?.is_new_user &&
      loginUserDetail?.data?.data?.role != "super_admin" &&
      loginUserDetail?.data?.data?.role != "admin" &&
      !loginUserDetail?.data?.data?.is_expired
    ) {
      if (expireLimit < numberPart) {
        newObject = {
          count: 0,
          key: "payment",
          label: `${loginUserDetail?.data?.data?.day_diff} remaining `,
        };
      } else {
        newObject = {
          count: 0,
          key: "payment",
          label: `${loginUserDetail?.data?.data?.day_diff}  until subscription expires `,
        };
      }
    }
    if (
      !loginUserDetail?.data?.data?.is_trial &&
      loginUserDetail?.data?.data?.role != "super_admin" &&
      loginUserDetail?.data?.data?.is_expired
    ) {
      newObject = {
        count: 0,
        key: "payment",
        label: ` Subscription expired!`,
      };
    }
  }
  let updatedCurrentItems = [];
  if (newObject.key == "payment") {
    updatedCurrentItems.push(newObject);
    currentItems?.map((item) => {
      updatedCurrentItems.push(item);
      return item;
    });
  } else {
    currentItems?.map((item) => {
      updatedCurrentItems.push(item);
      return item;
    });
  }
  const listnotification = updatedCurrentItems?.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  /** No of alert api calling main useeffect*/
  useEffect(() => {
    let payLoad = {};
    if (!homeList?.loading) {
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all" &&
        selectedHeaderPharmacyId !== undefined &&
        selectedHeaderPharmacyId !== null
      ) {
        payLoad = {
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        getNoOfAlertAction(payLoad);
      } else if (getLocalStorage("pharmacyChange") == "true") {
        getNoOfAlertAction(payLoad);
      }
      // getNoOfAlertAction(payLoad);
    }
  }, [selectedHeaderPharmacyId]);
  useEffect(() => {
    return () => {
      // // if (window.location.pathname === "/home") {
      // getNoOfAlertAction();
      // getGlobalSettingAction();
      window.onbeforeunload = null;
      setLocalStorage("pharmacyChange", false);
      // }
    };
  }, []);
  useEffect(() => {
    //Pharmacy header set in locat storage
    const selectedPharmcies = getLocalStorage("Pharmacies", true);
    if (selectedPharmcies != null && selectedPharmcies != "all") {
      setChangeDropDownValue(selectedPharmcies);
    } else {
      setChangeDropDownValue("all");
    }
    // getGlobalSettingAction();
  }, []);
  /** Pharmacy api useffect */
  useEffect(() => {
    if (
      !pharmacyConfigData?.loading &&
      !Object.keys(pharmacyConfigData?.data)?.length
    ) {
      getPharmacyConfigAction({ offset: 0, all_record: true });
    }
  }, [pharmacyConfigData]);

  /** Handle Change Pharmacy Drop-Down  */
  const handleChange = (event, value) => {
    setHeaderFileterPharmaciesAction({
      name: value?.props.children,
      id: value?.props?.value,
    });
    setLocalStorage("Pharmacies", value?.props?.value);
    setLocalStorage("pharmacyChange", true);
    setChangeDropDownValue(event?.target?.value);
    let payLoad = {};
    let temp = value?.props?.value;
    if (temp !== "all") {
      payLoad = {
        pharmacy_id: [temp],
      };
      getHomeListAction(payLoad);
      // getOrderSpeedAction(payLoad);
      // getChaseupChartAction(payLoad);
      // getOrderChartAction(payLoad);
      getNoOfAlertAction(payLoad);
      getCollectionCountAction(payLoad);
    } else {
      getHomeListAction();
      // getOrderSpeedAction();
      // getChaseupChartAction();
      // getOrderChartAction();
      getNoOfAlertAction();
      getCollectionCountAction();
    }
  };

  /** Handle Click Profile menu */
  const handleClickOpenProfileMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /** Handle Click Menu Close */
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  /** Handle Click Logout */
  const handleClickLogout = (e, item) => {
    if (item?.key === "logout") {
      localStorage.removeItem("dynamicColumnSequenceUnCollected");
      localStorage.removeItem("dynamicTableViewCollected");
      localStorage.removeItem("dynamicColumnUnCollected");
      logout();
    }
  };

  /** Set Header Title */
  const setHeaderTitle = () => {
    const activeModule = [...sidebarMenuItems].filter((item, index) => {
      return item.url === window.location.pathname;
    });
    setTitleApp &&
      setTitleApp(
        activeModule?.[0]?.hasOwnProperty("getTitle")
          ? activeModule?.[0].getTitle()
          : activeModule?.[0]?.value,
      );
    if (setSubTitleApp) {
      const sub = activeModule?.[0]?.hasOwnProperty("getSubTitle")
        ? activeModule?.[0].getSubTitle()
        : activeModule?.[0]?.subTitle;
      setSubTitleApp(sub || "");
    }
  };

  /** Set Header Location Useffect */
  useEffect(() => {
    setHeaderTitle();
  }, [location]);

  /** Order Mismatch Useffect */
  useEffect(() => {
    if (isOrderDateMismtachSelected) {
      navigate("/order?orderDateMissmatch=true");
    }
  }, [isOrderDateMismtachSelected]);

  /** Repeat Order List  Useffect */
  useEffect(() => {
    if (repeatOrderList?.data?.list?.length === 0) {
      navigate({
        search: createSearchParams(
          getRemovedUrlParam(["orderDateMissmatch"]),
        ).toString(),
      });
    }
  }, [repeatOrderList?.data?.list]);

  /** get list on entry  */
  useEffect(() => {
    if (entryPharmacy.isIntersecting && pharmacyConfigData.loading === false) {
      let params = {
        offset: pharmacyConfigData?.data?.list?.length || 0,
      };
      if (
        pharmacyConfigData?.data?.list?.length !==
        pharmacyConfigData?.data?.total
      ) {
        getPharmacyConfigAction(params);
      } else {
        setShowProgress(false);
      }
    }
  }, [entryPharmacy]);
  const handleEditProfile = () => {
    setProfileEditOpen(true);
  };

  useEffect(() => {
    if (loginUserDetail?.data?.data?.day_diff) {
      const trimmedString = loginUserDetail?.data?.data?.day_diff.trim();
      const parts = trimmedString?.split(" ");
      setNumberPart(parts[0]);
      setUnitPart(parts[1]);
    }
  }, [loginUserDetail?.data?.data]);
  const handleClose = () => {
    setRightBarsetting(false);
  };
  return (
    <Box sx={{ display: "flex" }}>
      <AppBar position="relative" className={classes.rsToolBarRoot}>
        <Toolbar style={{ paddingLeft: "10px" }}>
          <Box style={{ display: "flex", alignItems: "center" }}>
            {pin ? (
              <Box>
                <IconButton
                  className={classes.rspinBtn}
                  onClick={() => {
                    setPin(!pin);
                    setOpen(false);
                    setLocalStorage("pinSideDrawer", "false");
                  }}
                >
                  <CloseIconMain />
                </IconButton>
              </Box>
            ) : (
              <Box>
                <IconButton
                  className={classes.rspinBtn}
                  onClick={() => {
                    setPin(!pin);
                    setOpen(true);
                    setLocalStorage("pinSideDrawer", "true");
                  }}
                >
                  <MenuIcon />
                </IconButton>
              </Box>
            )}
            <PrimaryIcon
              style={{
                width: "200px",
                height: "65px",
                // marginLeft: "10px",
                // marginBottom: "-22px",
              }}
              icon={RepeatSmartApp}
              cursor="pointer"
              color="white"
            />
          </Box>
          {/* <Typography variant="h3" medium className={classes.rsMainTitle}>
            <Box className="RsTitle">{titleApp}</Box>
          </Typography> */}

          <Grid className={classes.rsHeaderRightSide}>
            {/* {loginUserDetail?.data?.data?.role !== "user" &&
              noOfAlertData?.data?.data?.is_notify === true && (
                <HtmlTooltip
                  title="The Order date should preceed the Medication starting date.
                Please amend this!"
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsOrderDateMismtachSelected(
                        !isOrderDateMismtachSelected
                      );
                    }}
                    style={{
                      marginRight: "10px",
                      display: "flex",
                    }}
                    startIcon={
                      <Typography
                        variant="h4"
                        medium
                        className="urgent_patients_effect"
                      >
                        <span>
                          <PrimaryIcon
                            icon={AlertIcon}
                            color="white"
                            width="20px"
                            height="20px"pr
                          />
                        </span>
                      </Typography>
                    }
                  >
                    Order dates are mismatched in{" "}
                    {noOfAlertData?.data?.data?.order_count}{" "}
                    {noOfAlertData?.data?.data?.order_count?.length === 1
                      ? "case"
                      : "cases"}
                  </Button>
                </HtmlTooltip>
              )} */}

            {/* WARNING HEADER COMPONENT */}

            {/* {listnotification?.length > 0 && (
              <Box className={classes.main}>
                <Pagination
                  totalItems={
                    newObject.key
                      ? noOfAlertData?.data?.data?.length + 1
                      : noOfAlertData?.data?.data?.length
                  }
                  itemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />

                {listnotification?.map((item, index) => (
                  <>
                    <Box className={classes.textIocn}>
                      <span>
                        {item?.key == "miss_match" ? (
                          <Refresh />
                        ) : (
                          <AlertIcon />
                        )}
                      </span>

                      <Box key={index}>{parse(item?.label)}</Box>
                    </Box>
                    <Button
                      variant="contained"
                      onClick={() => {
                        if (item?.key == "miss_match") {
                          setIsOrderDateMismtachSelected(
                            !isOrderDateMismtachSelected
                          );
                        } else if (item?.key == "unassigned") {
                          navigate("/order?unassigned=true");
                        } else {
                          setPaymentDialog(true);
                        }
                      }}
                    >
                      {item?.key == "miss_match"
                        ? "Fix now"
                        : item?.key == "unassigned"
                        ? "Add dates"
                        : "Pay now"}
                    </Button>
                  </>
                ))}
              </Box>
            )} */}
            {loginUserDetail?.data?.data?.role !== "nursing" && (
              <Box>
                <Button
                  onClick={() => {
                    navigate("/how-to");
                  }}
                  className={classes.howToBtn}
                  variant="contained"
                  style={{
                    width: "140px !important",
                  }}
                >
                  How to Videos
                </Button>
              </Box>
            )}
            {loginUserDetail?.data?.data?.role !== "nursing" && (
              <Box>
                <Button
                  onClick={() => {
                    window.open(process.env.REACT_APP_BOOK_DEMO_URL, "_blank");
                  }}
                  className={classes.btnWhite}
                  variant="contained"
                >
                  Book Demo
                </Button>
              </Box>
            )}

            {/* {loginUserDetail?.data?.data?.is_applied_payment && (
              <>
                {loginUserDetail?.data?.data?.is_trial &&
                  loginUserDetail?.data?.data?.role != "super_admin" &&
                  loginUserDetail?.data?.data?.is_new_user &&
                  (unitPart === "days" &&
                  !loginUserDetail?.data?.data?.is_expired ? (
                    <>
                      {numberPart > tempDays ? (
                        <Box
                          className={classes.rsBilling}
                        >{`Trial: ${loginUserDetail?.data?.data?.day_diff} left`}</Box>
                      ) : (
                        <Box className={classes.rsBillingdaysleft}>
                          {`Trial:  ${loginUserDetail?.data?.data?.day_diff} left `}
                        </Box>
                      )}
                    </>
                  ) : (
                    <>
                      <Box className={classes.rsBillingdaysleft}>
                        {`Trial: expired`}
                      </Box>
                    </>
                  ))}

                {!loginUserDetail?.data?.data?.is_trial &&
                  loginUserDetail?.data?.data?.is_new_user &&
                  loginUserDetail?.data?.data?.role != "super_admin" &&
                  loginUserDetail?.data?.data?.role != "admin" &&
                  !loginUserDetail?.data?.data?.is_expired && (
                    <Box className={classes.rsBilling}>
                      {expireLimit < numberPart
                        ? ""
                        : // `${loginUserDetail?.data?.data?.day_diff} remaining `
                          `${loginUserDetail?.data?.data?.day_diff}  until subscription expires `}
                    </Box>
                  )}

                {!loginUserDetail?.data?.data?.is_trial &&
                  loginUserDetail?.data?.data?.role != "super_admin" &&
                  loginUserDetail?.data?.data?.is_expired && (
                    <Box className={classes.rsBillingdaysleft}>
                      Subscription expired!
                    </Box>
                  )}
              </>
            )} */}
            {loginUserDetail?.data?.data?.is_applied_payment && (
              <>
                {/* {loginUserDetail?.data?.data?.is_new_user &&
                  loginUserDetail?.data?.data?.role != "super_admin" &&
                  (expireLimit < numberPart ? (
                    ""
                  ) : (
                    <Box className={classes.rsBilling}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setPaymentDialog(true);
                        }}
                      >
                        Billing ?
                      </Button>
                    </Box>
                  ))} */}
                {loginUserDetail?.data?.data?.role !== "nursing" &&
                  loginUserDetail?.data?.data?.is_trial &&
                  loginUserDetail?.data?.data?.is_new_user &&
                  loginUserDetail?.data?.data?.role != "super_admin" &&
                  loginUserDetail?.data?.data?.role != "admin" &&
                  (expireLimit > numberPart ? (
                    <Box className={classes.rsBilling}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setPaymentDialog(true);
                        }}
                      >
                        Billing ?
                      </Button>
                    </Box>
                  ) : null)}
              </>
            )}
            {loginUserDetail?.data?.data?.role !== "nursing" && (
              <Box className={classes.rshelpIconMain}>
                <IconButton
                  className={clsx("help_effect", classes.rshelpButton)}
                  variant="contained"
                  onClick={() => {
                    setRightBarsetting(!rightBarsetting);
                  }}
                >
                  <PrimaryIcon
                    icon={HelpIcon}
                    color="white"
                    width="20px"
                    height="20px"
                  />
                </IconButton>
              </Box>
            )}

            {/* is_new_user user false then show enable drop-down */}
            {loginUserDetail?.data?.data?.is_new_user === false ? (
              <>
                {/* {["admin", "super_admin", "user"].indexOf(
                  loginUserDetail?.data?.data?.role
                ) !== -1 && ( */}
                <FormControl
                  className={classes.rsFormControlRoot}
                  InputLabelProps={{ shrink: true }}
                >
                  <Select
                    value={changeDropDownValue}
                    onChange={(e, value) => handleChange(e, value)}
                    disabled={
                      [
                        "/surgery",
                        "/staff",
                        "/activity",
                        "/pharmacies",
                      ].indexOf(window.location.pathname) !== -1 ||
                      pharmacyConfigData?.loading
                    }
                    size="small"
                    MenuProps={{
                      style: {
                        maxHeight: 500,
                      },
                    }}
                  >
                    <MenuItem
                      value={"all"}
                      onClick={() => {
                        localStorage.removeItem("pharmacyEmail");
                        // localStorage.removeItem("pharmacyEmail");
                        // setLocalStorage("pharmacyEmail", null);
                      }}
                    >
                      All Branches
                    </MenuItem>
                    {pharmacyConfigData?.data?.list?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item?.id}
                        onClick={() => {
                          setLocalStorage(
                            "pharmacyEmail",
                            item?.cc_email ? item?.cc_email : null,
                          );
                        }}
                      >
                        {item?.name}
                      </MenuItem>
                    ))}
                    {pharmacyConfigData?.data?.list?.length !==
                      pharmacyConfigData?.data?.total && (
                        <MenuItem disabled ref={setTargetPharmacy}>
                          <CircularProgress size={20} />
                        </MenuItem>
                      )}
                  </Select>
                </FormControl>
                {/* )} */}
              </>
            ) : (
              <>
                {/* {["pharmacy", "pharmacist_staff", "user", "pharmacist"].indexOf(
                  loginUserDetail?.data?.data?.role
                ) !== -1 && ( */}
                <FormControl
                  className={classes.rsFormControlRootPharmacyStaff}
                  InputLabelProps={{ shrink: true }}
                  disabled={
                    [
                      "pharmacy",
                      "pharmacist_staff",
                      "user",
                      "pharmacist",
                    ].indexOf(loginUserDetail?.data?.data?.role) !== -1
                  }
                >
                  <Select
                    value={changeDropDownValue}
                    className={classes.select}
                    size="small"
                    IconComponent={null}
                  >
                    <MenuItem value={"all"}>
                      {loginUserDetail?.data?.data?.pharmacy_detail?.name
                        ? // loginUserDetail?.data?.data?.role === "user"
                        loginUserDetail?.data?.data?.pharmacy_detail?.name
                        : loginUserDetail?.data?.data?.name}
                    </MenuItem>
                  </Select>
                </FormControl>
                {/* )} */}
              </>
            )}
            <Avatar
              onClick={handleClickOpenProfileMenu}
              sx={{
                height: 38,
                width: 38,
                cursor: "pointer",
              }}
            >
              {capitalizeFirstLetter(loginUserDetail?.data?.data?.name[0])}
            </Avatar>
          </Grid>
        </Toolbar>
        {/* <Divider className={classes.rsDivider} /> */}
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            borderRadius: "10px",
            width: "10%",
            width: "206px",
            marginLeft: "0",
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem>
          <Avatar className={classes.rsProfileIcon}>
            {capitalizeFirstLetter(loginUserDetail?.data?.data?.name[0])}
          </Avatar>
          <Box
            display={"block"}
            onClick={() => {
              handleEditProfile();
            }}
          >
            <HtmlTooltip
              title={capitalizeFirstLetter(loginUserDetail?.data?.data?.name)}
            >
              <Box
                className={classes.rsUserName}
                onClick={() => {
                  handleEditProfile();
                }}
              >
                {loginUserDetail?.data?.data?.name.split(" ")[0]}
              </Box>
            </HtmlTooltip>
            {["pharmacist_staff", "user", "pharmacist"].indexOf(
              loginUserDetail?.data?.data?.role,
            ) !== -1 && (
                <Typography variant="h6" medium className={classes.rsProfileRole}>
                  {capitalizeFirstLetter(
                    loginUserDetail?.data?.data?.role === "pharmacist_staff"
                      ? "pharmacist Staff"
                      : loginUserDetail?.data?.data?.role,
                  )}
                </Typography>
              )}
          </Box>
        </MenuItem>
        <Divider sx={{ background: "#F7F7F8 !important" }} />
        {profileMenuItem?.map((item) => {
          return (
            <MenuItem onClick={(e) => handleClickLogout(e, item)}>
              <Logout
                style={{
                  height: 20,
                  width: 20,
                  marginRight: "15px",
                }}
              />
              {item.value}
            </MenuItem>
          );
        })}
      </Menu>
      {rightBarsetting && (
        <Box className={classes.rsBoxColor}>
          <Box className={classes.rsrighttitlecolor}>
            <Box className={classes.rsIconMain}>
              <PrimaryIcon
                style={{
                  width: "90%",
                  height: "65px",
                  marginLeft: "10px",
                  // marginBottom: "-22px",
                }}
                icon={RepeatSmart}
              />
            </Box>
            <Typography variant="h4">Resource Center</Typography>
            <IconButton
              onClick={() => handleClose()}
              className={classes.rsCloseIcon}
            >
              {" "}
              <PrimaryIcon icon={CloseIcon} />{" "}
            </IconButton>
          </Box>
          {helpMenuList.map((item) => {
            return loginUserDetail?.data?.data?.role !== "admin" &&
              loginUserDetail?.data?.data?.is_applied_payment &&
              item?.id !== "billing" ? (
              <Box
                className={classes.rsRowMain}
                onClick={() => {
                  if (item?.id === "contact") {
                    setOpenContactDialog(true);
                  }
                  if (item?.id === "billing") {
                    setPaymentDialog(true);
                  }
                  if (item?.navigation) {
                    navigate(item?.navigation);
                    // setLinkvideo(item?.link);
                    // setTitle(item?.title);
                    // setVideoDialogOpen(true);
                  }
                }}
              >
                <Typography variant="h5">{item?.title}</Typography>
                <PrimaryIcon icon={ChevronRightIcon} />
              </Box>
            ) : item?.id === "billing" &&
              loginUserDetail?.data?.data?.is_new_user === false ? (
              ""
            ) : (
              <Box
                className={classes.rsRowMain}
                onClick={() => {
                  if (item?.id === "contact") {
                    setOpenContactDialog(true);
                  }
                  if (item?.id === "billing") {
                    setPaymentDialog(true);
                  }
                  if (item?.navigation) {
                    navigate(item?.navigation);
                    // setLinkvideo(item?.link);
                    // setTitle(item?.title);
                    // setVideoDialogOpen(true);
                  }
                }}
              >
                <Typography variant="h5">{item?.title}</Typography>
                <PrimaryIcon icon={ChevronRightIcon} />
              </Box>
            );
          })}
        </Box>
      )}
      <EditProfileDialog open={profileEditOpen} setOpen={setProfileEditOpen} />
      {paymentDialog && (
        <BillingDialog open={paymentDialog} setOpen={setPaymentDialog} />
      )}
      <ContactUsDialog
        open={openContactDialog}
        setOpen={setOpenContactDialog}
      />
      <VideoDialogMain
        open={videoDialogOpen}
        setOpen={setVideoDialogOpen}
        link={linkvideo}
        title={title}
      />
    </Box>
  );
}

const mapStateToProps = (state) => ({
  loginUserDetail: state.user.loginUserDetail,
  pharmacyConfigData: state.user.pharmacyConfigData,
  noOfAlertData: state.home.noOfAlertData,
  repeatOrderList: state.order.repeatOrderList,
  homeList: state.home.homeList,
  pharmacyList: state.patient.pharmacyList,
});
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch({ type: LOGOUT_START }),
  getPharmacyConfigAction: (payload) =>
    dispatch({ type: START_GET_PHARMACY_CONFIG, payload }),
  setHeaderFileterPharmaciesAction: (payload) =>
    dispatch({ type: SET_HEADER_FILTER_PHARMACIES, payload }),
  getNoOfAlertAction: (payload) =>
    dispatch({ type: START_GET_NO_OF_ALERT, payload }),
  getGlobalSettingAction: () => dispatch({ type: START_GLOBAL_SETTING }),
  getPharmacyListAction: (payload) =>
    dispatch({ type: START_PHARMACY_LIST, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  getCollectionCountAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_COUNT, payload }),
  getOrderSpeedAction: (payload) =>
    dispatch({ type: START_ORDER_SPEED, payload }),
  getChaseupChartAction: (payload) =>
    dispatch({ type: START_CHASEUP_CHART, payload }),
  getOrderChartAction: (payload) =>
    dispatch({ type: START_ORDER_CHART, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
